import { Input, Tree, Button, Space, Row } from 'antd';
import { useState } from 'react';
import DataUtil from './DataUtil';
const { Search } = Input;

const defaultData = [];

const dataList = [];

const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};
const MetricTree = ({inputValue }) => {
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  
  const onExpand = (newExpandedKeys) => {
    setExpandedKeys(newExpandedKeys);
    setAutoExpandParent(false);
  };
  const onChange = (e) => {
    const { value } = e.target;
    const newExpandedKeys = dataList
      .map((item) => {
        if (item.title.indexOf(value) > -1) {
          return getParentKey(item.key, defaultData);
        }
        return null;
      })
      .filter((item, i, self) => item && self.indexOf(item) === i);
    setExpandedKeys(newExpandedKeys);
   
    setAutoExpandParent(true);
  };

  const handleExpand = () => {
    const newExpandedKeys = DataUtil.getDataList(inputValue);
    setExpandedKeys(newExpandedKeys);
  }
  const handleFold = () => {
    setExpandedKeys([]);
  }
  const treeData = DataUtil.Data2Tree(inputValue);
  
  return (
    <div>
      <Space size={8} style={{width: '1800px'}}>
      <Button type="primary" onClick={handleExpand} >Extand</Button>
      <Button type="primary" onClick={handleFold} >Fold</Button>
      </Space>
      <Tree style={{width: '18000px'}}
        onExpand={onExpand}
        expandedKeys={expandedKeys}
        autoExpandParent={autoExpandParent}
        treeData={treeData}
      />
    </div>
  );
};
export default MetricTree;

